// @owners { team: patients }
import { ActionSheetContext } from '@alto/design-system';
import {
  type PrescriptionStatus,
  PrescriptionStatusMap,
} from '@alto/scriptdash/alto/patient_app/types/v1/prescription_status';
import React, { useContext } from 'react';
import { PrescriptionStatusTracker } from '../../alto-assistant';
import { WaitingOnProgynyTag } from './WaitingOnProgynyTag';

type Props = {
  readonly prescriptionId: number | undefined;
  readonly prescriptionName: string;
  readonly prescriptionStatus: PrescriptionStatus | undefined;
  readonly origin: 'Homescreen' | 'MedList' | 'MedDetails';
};

/**
 * Renders the tappable "waiting on progyny" tag for progyny early-order-eligible prescriptions.
 * Tapping it opens the prescription status tracker. Renders nothing when the prescription is not
 * progyny early-order eligible — so callers can drop it into a layout unconditionally.
 */
export const ProgynyEarlyOrderTag = ({ prescriptionId, prescriptionName, prescriptionStatus, origin }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  if (prescriptionStatus !== PrescriptionStatusMap.PROGYNY_EARLY_ORDER_ELIGIBLE) {
    return null;
  }

  return (
    <WaitingOnProgynyTag
      onPress={() => {
        setActiveActionSheet(
          <PrescriptionStatusTracker
            origin={origin}
            prescriptionId={prescriptionId}
            prescriptionName={prescriptionName}
            prescriptionStatus={prescriptionStatus}
          />,
        );
      }}
    />
  );
};
